export default __webpack_public_path__ + "static/media/icon-route-marker.ae8a913f.svg";